import { Hotkeys } from 'constants/Hotkeys';
import { ISequence } from 'interfaces/tagging/ISequence';
import React, { memo } from 'react';
import BottomBarOption from './components/BottomBarOption';
import { SequenceBottomBarWrapper } from './SequenceBottomBarStyles';

interface IProps {
  onSaveCallback: () => void;
  onDeleteCallback: () => void;
  onExitCallback: () => void;
  sequence: ISequence[];
}

const SequenceBottomBar: React.FC<IProps> = (props) => {
  const { onSaveCallback, onDeleteCallback, onExitCallback, sequence } = props;

  return (
    <SequenceBottomBarWrapper>
      <BottomBarOption
        className='exit-sequence'
        displayName='Exit sequence'
        hotkey={Hotkeys.FieldingSequence.ExitSequence.hotkeyDisplay}
        keyCode={Hotkeys.FieldingSequence.ExitSequence.keyCode}
        label={sequence.length === 0 ? 'Exit sequence? (Discard changes)' : 'Exit sequence?'}
        onPressHotkeyCallback={onExitCallback}
        data-testid='exit-sequence'
      />
      {sequence.length > 0 && (
        <>
          <BottomBarOption
            className='change-selection'
            displayName='Change last'
            hotkey={Hotkeys.FieldingSequence.ChangeSelection.hotkeyDisplay}
            keyCode={Hotkeys.FieldingSequence.ChangeSelection.keyCode}
            label='Change last?'
            onPressHotkeyCallback={onDeleteCallback}
            data-testid='change-last'
          />
          <BottomBarOption
            className='save-sequence'
            displayName='Save changes?'
            hotkey={Hotkeys.FieldingSequence.SaveAndExit.hotkeyDisplay}
            keyCode={Hotkeys.FieldingSequence.SaveAndExit.keyCode}
            label='Save changes?'
            onPressHotkeyCallback={onSaveCallback}
            data-testid='save-changes'
          />
        </>
      )}
    </SequenceBottomBarWrapper>
  );
};

export default memo(SequenceBottomBar);
